import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Input, Button } from "reactstrap";
import DatePicker from "react-datepicker";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { URL } from "../../api";
import axiosInstance from "../../Request";
import "react-datepicker/dist/react-datepicker.css";
import getPrivilegeList from "../../PrivilegeList";

const CustomerDetailsForm = ({ customerDetails, disableEdit }) => {
  const { cid } = useParams();
  const privilegeList = getPrivilegeList();
  console.log(privilegeList?.customerDetailsEdit);
  console.log("privilegeList.customerDetailsEdit");
  const [editableDetails, setEditableDetails] = useState({
    borrowerName: "-NA-",
    mobileNumber: "-NA-",
    email: "-NA-",
    gender: 0,
    dob: null,
    panNumber: "-NA-",
    aadhaarNumber: "-NA-",
    fatherName: "-NA-",
    ckycId: "-NA-",
    accountNumber: "-NA-",
    ifscCode: "-NA-",
    upiId: "-NA-",
  });
  const [isEditable, setIsEditable] = useState(false);
  const [initialDetails, setInitialDetails] = useState({
    borrowerName: "-NA-",
    mobileNumber: "-NA-",
    email: "-NA-",
    gender: 0,
    dob: null,
    panNumber: "-NA-",
    aadhaarNumber: "-NA-",
    fatherName: "-NA-",
    ckycId: "-NA-",
    accountNumber: "-NA-",
    ifscCode: "-NA-",
    upiId: "-NA-",
  });

  useEffect(() => {
    if (customerDetails && customerDetails.customer) {
      const details = customerDetails.customer;
      const detail = customerDetails.bankDetails || {};
      setEditableDetails({
        borrowerName: details.borrowerName || "-NA-",
        mobileNumber: details.mobileNumber || "-NA-",
        email: details.email || "-NA-",
        gender: details.gender || 0,
        dob: details.dob ? new Date(details.dob) : null,
        panNumber: details.panNumber || "-NA-",
        aadhaarNumber: details.aadhaarNumber || "-NA-",
        accountNumber: detail.accountNumber || "-NA-",
        ifscCode: detail.ifscCode || "-NA-",
        upiId: detail.upiId || "-NA-",
        fatherName: details.fatherName || "-NA-",
        ckycId: details.ckycId || "-NA-",
      });
      setInitialDetails({
        borrowerName: details.borrowerName || "-NA-",
        mobileNumber: details.mobileNumber || "-NA-",
        email: details.email || "-NA-",
        gender: details.gender || 0,
        dob: details.dob ? new Date(details.dob) : null,
        panNumber: details.panNumber || "-NA-",
        aadhaarNumber: details.aadhaarNumber || "-NA-",
        accountNumber: detail.accountNumber || "-NA-",
        ifscCode: detail.ifscCode || "-NA-",
        upiId: detail.upiId || "-NA-",
      });
    }
  }, [customerDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleGenderChange = (value) => {
    setEditableDetails((prevState) => ({
      ...prevState,
      gender: value,
    }));
  };

  const handleCancelClick = () => {
    setEditableDetails({ ...initialDetails });
    setIsEditable(false);
  };

  const handleUpdateClick = () => {
    updateCustomerDetails(editableDetails);
    setIsEditable(false);
  };

  const updateCustomerDetails = async (details) => {
    const payload = {
      customer_id: cid,
      first_name: details.borrowerName,
      gender: details.gender,
      dob: details.dob ? details.dob.toISOString().split("T")[0] : null,
      father_name: details.fatherName,
      ckyc_id: details.ckycId,
    };

    try {
      const response = await axiosInstance.post(
        URL.UPDATE_CUSTOMER_DETAILS,
        payload
      );
      const result = response.data;

      if (response.status === 200) {
        toast.success(
          result.message || "Customer details updated successfully"
        );
      } else {
        toast.warning(result.message || "Update failed");
      }
    } catch (error) {
      toast.warning("Error updating customer details:", error);
    }
  };
  return (
    <div>
      <div className="pl-lg-4">
        <Row>
          <Col lg="12">
            <FormGroup>
              <label className="form-control-label">Name</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="borrowerName"
                value={editableDetails.borrowerName}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Phone</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="mobileNumber"
                value={
                  privilegeList.customerDetailsContactInfoShow
                    ? editableDetails.mobileNumber
                    : editableDetails.mobileNumber
                    ? "******" + editableDetails.mobileNumber.slice(-4)
                    : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Email address</label>
              <Input
                className="form-control-alternative"
                type="email"
                name="email"
                value={
                  privilegeList.customerDetailsContactInfoShow
                    ? editableDetails.email
                    : editableDetails.email
                    ? "******@" + editableDetails.email.split("@")[1]
                    : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Gender</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="gender"
                  className="form-check-input form-control-alternative"
                  checked={editableDetails.gender === 1}
                  onChange={() => handleGenderChange(1)}
                  disabled={!isEditable}
                />
                <label className="form-check-label">Male</label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="gender"
                  className="form-check-input form-control-alternative"
                  checked={editableDetails.gender === 2}
                  onChange={() => handleGenderChange(2)}
                  disabled={!isEditable}
                />
                <label className="form-check-label">Female</label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="gender"
                  className="form-check-input form-control-alternative"
                  checked={editableDetails.gender === 3}
                  onChange={() => handleGenderChange(3)}
                  disabled={!isEditable}
                />
                <label className="form-check-label">Other</label>
              </div>
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">DOB</label>
              <div>
                <DatePicker
                  className="form-control form-control-alternative"
                  selected={editableDetails.dob}
                  onChange={(date) =>
                    setEditableDetails((prevState) => ({
                      ...prevState,
                      dob: date,
                    }))
                  }
                  disabled={!isEditable}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select Date of Birth"
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">PAN</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="panNumber"
                value={
                  privilegeList.customerDetailsIdInfoShow
                    ? editableDetails.panNumber
                    : editableDetails.panNumber
                    ? "*****" + editableDetails.panNumber.slice(-5)
                    : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Aadhaar</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="aadhaarNumber"
                value={
                  privilegeList.customerDetailsIdInfoShow
                    ? editableDetails.aadhaarNumber
                    : editableDetails.aadhaarNumber
                    ? "********" + editableDetails.aadhaarNumber.slice(-4)
                    : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Father's Name</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="fatherName"
                value={editableDetails.fatherName}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">CKYC ID</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="ckycId"
                value={editableDetails.ckycId}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">Account No</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="accountNumber"
                value={
                  privilegeList.bankingDetailsBankingInfoShow
                    ? editableDetails.accountNumber
                    : "************"
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>

          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">IFSC Code</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="ifscCode"
                value={
                  privilegeList.bankingDetailsBankingInfoShow
                    ? editableDetails.ifscCode
                    : editableDetails.ifscCode &&
                      typeof editableDetails.ifscCode === "string"
                    ? "*****" + editableDetails.ifscCode.slice(-3)
                    : ""
                }
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>

          <Col lg="6">
            <FormGroup>
              <label className="form-control-label">UPI ID</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="upiId"
                value={editableDetails.upiId}
                onChange={handleInputChange}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        {privilegeList?.customerDetailsEdit && !disableEdit && (
          <Row>
            <Col className="text-right" xs="12">
              {!isEditable ? (
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setIsEditable(true)}
                >
                  Edit
                </Button>
              ) : (
                <>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={handleCancelClick}
                    className="mr-2"
                  >
                    Cancel
                  </Button>
                  <Button color="primary" size="sm" onClick={handleUpdateClick}>
                    Update
                  </Button>
                </>
              )}
            </Col>
          </Row>
        )}
      </div>
      <hr className="my-4" />
    </div>
  );
};



export default CustomerDetailsForm;
